import { CommodityDetail } from "features/contracts/enums/commodityDetail";
import React from "react";
import { FuelingTransactionViewType } from "../enums/fuelingTransactionViewType";
import { useSelector } from "react-redux";
import IAppState from "infrastructure/store/IAppState";
import CustomerState from "infrastructure/store/customer/CustomerState";
import { Fueling_FuelingSummaryDetail, Fueling_FuelingTransactionsExport } from "data/endpoints";
import { FuelingSummaryDetailDTO } from "../dtos/FuelingSummaryDetailDTO";
import FuelingSummaryDetail from "../components/FuelingSummaryDetail";
import FuelingSummaryDetailHeader from "../components/FuelingSummaryDetailHeader";
import DataGridState from "features/shared/components/dataGrid/DataGridState";
import { loadDataFilterConfig } from "features/shared/helpers/modules";
import { useInjection } from "infrastructure/ioc/ioc.react";
import IFileService from "data/IFileService";
import { IocTypes } from "infrastructure/ioc/ioc.types";
import DataQuery from "data/DataQuery";
import { endOfMonth, formatISO } from "date-fns";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { useTranslation } from "react-i18next";

const fuelingSummaryDetailsDataFilterJson = loadDataFilterConfig(
  "fuelingSummaryDetailsDataFilter"
);
const pageSize = 10;

type Props = {
  year: number;
  month: number;
  viewType: FuelingTransactionViewType;
  commodityDetail: CommodityDetail;
};

const FuelingSummaryDetailListSection = ({
  year,
  month,
  viewType,
  commodityDetail,
}: Props) => {
  // transaltions
  const tLabels = useTranslation("fueling\\fueling").t;

  // DI
  const fileService = useInjection<IFileService>(IocTypes.FileService);

  // store
  const customer = useSelector<IAppState, CustomerState>(
    (store) => store.customer
  ).customer;

  // handlers
  const downloadTransactionsExcelHandler = (entityType?: string, entityId?: string) => {
    let queryParams = new URLSearchParams({
      CustomerId: customer.customerId!,
      From: formatISO(new Date(year, month - 1, 1), { representation: "date" }),
      To: formatISO(endOfMonth(new Date(year, month - 1, 1)), { representation: "date" }),
      ViewType: viewType
    });

    if (entityType && entityId) {
      queryParams.set(entityType, entityId);
    }

    let query: DataQuery = {
      url: Fueling_FuelingTransactionsExport,
      params: queryParams,
    };
    
    fileService.downloadFile(query);
  } 

  // sub-renders
  const renderSummaryDetail = (item: FuelingSummaryDetailDTO) => {
    return (
      <FuelingSummaryDetail
        summaryDetail={item}
        commodityDetail={commodityDetail}
        onDownloadClick={downloadTransactionsExcelHandler}
      />
    );
  };

  const renderHeader = () => {
    return (
      <FuelingSummaryDetailHeader
        fuelingUnit={"kWh"}
        commodityDetail={commodityDetail}
        viewType={viewType}
      />
    );
  };

  const renderDownloadExcelBtn = (): JSX.Element => {
    return (
      <button
        className="btn btn-sm btn-secondary"
        onClick={() => downloadTransactionsExcelHandler()}
      >
        <span className="mr-2">
          <FontAwesomeIcon icon="file-excel" />
        </span>
        {tLabels("fuelingSummaryDetailListSection.downloadExcel")}
      </button>
    );
  };

  // render
  return (
    <DataGridState
      url={Fueling_FuelingSummaryDetail}
      pageSize={pageSize}
      filterJson={fuelingSummaryDetailsDataFilterJson}
      renderItem={renderSummaryDetail}
      renderHeader={renderHeader}
      noFilterQueryParams={
        new URLSearchParams({
          CustomerId: customer.customerId!,
          ViewType: viewType,
        })
      }
      routeParams={
        new URLSearchParams({
          year: String(year),
          month: String(month),
        })
      }
      renderGridHeaderBtns={renderDownloadExcelBtn}
    />
  );
};

export default FuelingSummaryDetailListSection;
